import { render, staticRenderFns } from "./takingsTransferModal.vue?vue&type=template&id=83c6c242&"
import script from "./takingsTransferModal.vue?vue&type=script&lang=ts&"
export * from "./takingsTransferModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports